import React from 'react';
import './css/Footer.css'

const Footer = () => {
  return (
    <footer>
      <div className="footer-top">
        <div className="footer-brand">
          <div className="logo">
            <div className="logo-icon">
              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <circle cx="5" cy="17" r="3" fill="none" stroke="white" strokeWidth="2" />
                <circle cx="19" cy="17" r="3" fill="none" stroke="white" strokeWidth="2" />
                <path d="M5 17L9 6h6l4 11" stroke="white" strokeWidth="2" fill="none" />
              </svg>
            </div>
            <div className="logo-text">WALNUT<sup>®</sup></div>
          </div>
          <p>Premium bike spare parts manufacturer and exporter with 46+ years of experience. Built for performance, engineered for reliability.</p>
          <div style={{ marginTop: '20px' }}>
  <div style={{ fontSize: '12px', color: '#555', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '1px' }}>
    Follow Us
  </div>
<div className="social-links">
  {/* LinkedIn */}
 <a
  href="https://www.linkedin.com/in/sahil-garg-6218a558"
  target="_blank"
  rel="noopener noreferrer"
  className="soc-linkedin"
  title="LinkedIn"
  aria-label="LinkedIn"
>
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
  >
    <path d="M4.98 3.5C4.98 4.88 3.86 6 2.48 6S0 4.88 0 3.5 1.12 1 2.48 1s2.5 1.12 2.5 2.5zM.5 8h4V24h-4V8zm7 0h3.84v2.16h.06c.53-1.01 1.84-2.08 3.79-2.08C19.23 8.08 21 10.29 21 14.29V24h-4v-8.43c0-2.01-.04-4.59-2.8-4.59-2.8 0-3.23 2.19-3.23 4.45V24h-4V8z" />
  </svg>
</a>

  {/* Facebook */}
  <a
    href="https://www.facebook.com/profile.php?id=61591319054206"
    target="_blank"
    rel="noopener noreferrer"
    className="soc-facebook"
    title="Facebook"
    aria-label="Facebook"
  >
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M22 12A10 10 0 1 0 10.44 21.88v-6.99H7.9V12h2.54V9.8c0-2.5 1.49-3.89 3.77-3.89 1.09 0 2.23.2 2.23.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56V12h2.77l-.44 2.89h-2.33v6.99A10 10 0 0 0 22 12z" />
    </svg>
  </a>

  {/* Instagram */}
  <a
    href="https://www.instagram.com/walnutindustries_?igsh=ZzdmMnR0OHM2bGwz"
    target="_blank"
    rel="noopener noreferrer"
    className="soc-instagram"
    title="Instagram"
    aria-label="Instagram"
  >
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M7.75 2C4.57 2 2 4.57 2 7.75v8.5C2 19.43 4.57 22 7.75 22h8.5C19.43 22 22 19.43 22 16.25v-8.5C22 4.57 19.43 2 16.25 2h-8.5zm0 2h8.5A3.75 3.75 0 0 1 20 7.75v8.5A3.75 3.75 0 0 1 16.25 20h-8.5A3.75 3.75 0 0 1 4 16.25v-8.5A3.75 3.75 0 0 1 7.75 4zm8.75 1a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5zM12 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm0 2a3 3 0 1 1 0 6 3 3 0 0 1 0-6z" />
    </svg>
  </a>
</div>
</div>
        </div>
        <div className="footer-col">
          <h4>For Customers</h4>
          <ul>
            <li><a href="/about">About Us</a></li>
            <li><a href="/contact">Contact Us</a></li>
            <li><a href="/exports">Export</a></li>
            <li><a href="/products">Products</a></li>
            <li><a href="/">Home</a></li>
          </ul>
        </div>
        <div className="footer-col">
          <h4>Consumer Policy</h4>
          <ul>
            <li><a href="/privacy-policy">Privacy Policy</a></li>
            <li><a href="/return-policy">Return Policy</a></li>
            <li><a href="/terms-conditions">Terms & Conditions</a></li>
          </ul>
        </div>
        <div className="footer-col">
          <h4>We Accept</h4>
         <div className="payment-icons" style={{ flexWrap: 'wrap', gap: '8px' }}>
          <div className="pay-badge">Bank Transfer</div>
          <div className="pay-badge">NEFT / RTGS</div>
          <div className="pay-badge">UPI</div>
          <div className="pay-badge">Wire Transfer</div>
        </div>
          <div style={{ marginTop: '24px' }}>
            <h4>Contact</h4>
            <p style={{ fontSize: '13px', color: '#666', marginTop: '8px', lineHeight: '1.8' }}>
              support@wnindustries.com<br />
              +91 98760 03074<br />
              Mon–Sat, 9AM–6PM IST
            </p>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>© 2026 Walnut. All Rights Reserved.</p>
        <p>Designed & Developed for Walnut Bike Spare Parts</p>
      </div>
    </footer>
  );
};

export default Footer;